(function() {
  'use strict';

  angular
    .module('quiz.sequence', [])
    .controller('SequenceCtrl', SequenceCtrl);

  SequenceCtrl.$inject = ['$scope', '$timeout'];

  function SequenceCtrl($scope, $timeout) {
    // options for the ui-sortable directive
    $scope.sortableOptions = {
      disabled: false,
      placeholder: "sq-answer-under",
      tolerance: 'pointer',
      axis: 'y',
      stop: function() {
//        Super crazy fix to force ngRepeat to redraw according to the model to work around a DOM bug in jquery-ui
        var prevModel = $scope.questionAnswers;
        $scope.questionAnswers = [];
        $timeout(function() {
          $scope.questionAnswers = prevModel;
          setSelectedAnswers();
        }, 10);
      }
    };

    $scope.$watch('state.answerGraded', updateDragState);
    $scope.state.answerSelected = false;

    var originalAnswers = [];

    $scope.$watch('state.answerSubmitted', function(newValue, oldValue) {
      if (!newValue) return;

      originalAnswers = $scope.questionAnswers.concat();
      updateDragState();
    });

    function updateDragState() {
      $scope.sortableOptions.disabled = $scope.state.answerGraded || $scope.state.answerSubmitted;
    }

    $scope.$watch('state.showAnswersRequested', function(newValue, oldValue) {
      if (originalAnswers.length === 0) return;
      if (!newValue) {
        $scope.questionAnswers = originalAnswers.concat();
      } else if (_.isArray($scope.question.correctAnswer)) {
        $scope.questionAnswers = $scope.question.correctAnswer.concat();
      }
    });

    $scope.$watch('state.tryAgainRequested', function(newValue, oldValue) {
      if (!newValue) return;
      $scope.questionAnswers = _.shuffle($scope.questionAnswers);
      $scope.currentSlide.numPoints = 0;
      setSelectedAnswers();
    });

    function setSelectedAnswers() {
      // update the answers we'll eventually submit to the server
      $scope.answer.selectedAnswer = $scope.questionAnswers.concat();
      $scope.storeSelectedAnswer();
      $scope.state.answerSelected = true;
    }

    $scope.getRowIndicatorText = function(index) {
      if (showRowResultIcon())
        return '';

      return (index + 1).toString();
    };

    $scope.getRowIndicatorStyle = function(answer) {
      if (!showRowResultIcon()) return 'rowNumber';

      // return all green checks for partial-correct show-answers
      if ($scope.question.partialCorrect && $scope.state.showAnswersRequested)
        return 'correct fa fa-lg fa-check';

      return $scope.question.gradedOptionIndices[answer] ? 'correct fa fa-lg fa-check' : 'incorrect fa fa-lg fa-times';
    };

    function showRowResultIcon() {
      if (!$scope.state.answerGraded) return false;
      if (!$scope.question.partialCorrect) return false;
      if (!$scope.question.gradedOptionIndices) return false;

      return true;
    }

    $scope.getAnswerText = function(index) {
      return $scope.questionAnswers[index];
    };
  }
})();
